import React, { useCallback, useEffect, useState } from "react";
import "./organization.css";
import Tab from "../tab/tab";
import profile_c from "../../../assets/img/profile_c.png";
import profile_d from "../../../assets/img/profile_d.png";
import { publicApiClient } from "../../../api/apiClient";

const EXECUTIVES_API = "/api/council/org/executives";
const UNITS_API = "/api/council/org/units";

const getArrayData = (result) => {
  const data = result?.data;

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.content)) return data.content;
  if (Array.isArray(data?.list)) return data.list;
  if (Array.isArray(data?.items)) return data.items;

  return [];
};

const normalizeChairman = (item) => ({
  id: item.orgId,
  name: item.name || "",
  role: item.position || "",
  major: item.studentId || "",
  img: profile_c,
});

const normalizeDepartment = (item) => {
  const members = Array.isArray(item.members)
    ? item.members
        .map((member) => member.memberName || "")
        .filter(Boolean)
        .join(", ")
    : "";

  return {
    id: item.orgUnitId,
    dept: item.unitName || "",
    role: "국장",
    name: item.headName || "",
    major: item.headStudentId || "",
    members,
  };
};

export default function Organization() {
  const [chairmen, setChairmen] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const fetchOrganization = useCallback(async () => {
    try {
      setLoading(true);
      setErrorMsg("");

      const [executivesResult, unitsResult] = await Promise.all([
        publicApiClient(EXECUTIVES_API),
        publicApiClient(UNITS_API),
      ]);

      const executiveData = getArrayData(executivesResult).map(
        normalizeChairman
      );

      const unitData = getArrayData(unitsResult).map(normalizeDepartment);

      setChairmen(executiveData);
      setDepartments(unitData);
    } catch (error) {
      console.error("조직도 조회 오류:", error);
      setErrorMsg(error.message || "조직도 정보를 불러오지 못했습니다.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOrganization();
  }, [fetchOrganization]);

  const array = (arr, size) => {
    const result = [];

    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }

    return result;
  };

  const renderMembers = (members) => {
    if (!members) return null;

    const memberList = members.split(", ");
    const rows = [];

    for (let i = 0; i < memberList.length; i += 2) {
      rows.push(memberList.slice(i, i + 2).join(", "));
    }

    return (
      <>
        <span className="members-pc">{members}</span>

        <span className="members-mobile">
          {rows.map((row, index) => (
            <React.Fragment key={index}>
              {row}
              {index !== rows.length - 1 && <br />}
            </React.Fragment>
          ))}
        </span>
      </>
    );
  };

  const departmentGroups = array(departments, 2);

  if (loading) {
    return (
      <div className="council-org-page">
        <Tab />
        <p className="org-loading">조직도 정보를 불러오는 중입니다.</p>
      </div>
    );
  }

  if (errorMsg) {
    return (
      <div className="council-org-page">
        <Tab />
        <p className="org-loading">{errorMsg}</p>
      </div>
    );
  }

  return (
    <div className="council-org-page">
      <Tab />

      <div className="pre-class">
        <h3>회장단</h3>
      </div>

      {chairmen.length > 0 ? (
        <div className="chairmen-grid">
          {chairmen.map((person, i) => (
            <div className="org-item" key={person.id || i}>
              <div className="org-photo-wrapper">
                <img src={person.img} alt={person.role} className="org-photo" />
              </div>

              <div className="org-header">
                <span className="name">{person.name}</span>
                <span className="role">{person.role}</span>
              </div>

              <p>{person.major}</p>
            </div>
          ))}
        </div>
      ) : (
        <p className="org-loading">등록된 회장단 정보가 없습니다.</p>
      )}

      <div className="pre-class">
        <h3>중앙집행국</h3>
      </div>

      {departments.length > 0 ? (
        departmentGroups.map((group, i) => (
          <div
            key={i}
            className={`dept-grid ${group.length === 1 ? "single" : ""}`}
          >
            {group.map((person, j) => (
              <div className="org-item dept" key={person.id || j}>
                <div className="org-photo-wrapper">
                  <img src={profile_d} alt={person.dept} className="org-photo" />

                  {person.members && (
                    <div className="org-hover">
                      <h4>국원</h4>
                      <p>{renderMembers(person.members)}</p>
                    </div>
                  )}
                </div>

                <div className="org-role">
                  <span className="dept-name">{person.dept}</span>
                  <span className="role">{person.role}</span>
                </div>

                <div className="org-name">
                  <span className="name">{person.name}</span>
                  <span className="major">{person.major}</span>
                </div>
              </div>
            ))}
          </div>
        ))
      ) : (
        <p className="org-loading">등록된 중앙집행국 정보가 없습니다.</p>
      )}
    </div>
  );
}